/* ==========================================================================
   Leiva's design layer — assets/leivas-design.js
   Skips all initialization if the "Enable design layer" master switch is
   off (no .lv-design-on on <body>), matching the CSS file's scoping.
   ========================================================================== */

(function () {
  'use strict';

  function initCard(card) {
    if (card.dataset.lvInit === 'true') return;
    card.dataset.lvInit = 'true';

    card.addEventListener('mouseenter', function () {
      card.classList.add('is-active');
    });

    card.addEventListener('mouseleave', function () {
      card.classList.remove('is-active');
    });

    card.addEventListener('click', function (event) {
      if (event.target.closest('form')) return;
      var url = card.getAttribute('data-product-url');
      if (url) window.location.href = url;
    });

    card.addEventListener('keydown', function (event) {
      var isActivationKey = event.key === 'Enter' || event.key === ' ';
      if (!isActivationKey || event.target.closest('form')) return;
      event.preventDefault();
      var url = card.getAttribute('data-product-url');
      if (url) window.location.href = url;
    });
  }

  function initReveal(root) {
    var targets = root.querySelectorAll('[data-reveal]');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initSection(root) {
    if (!root) return;
    root.querySelectorAll('.lv-card').forEach(initCard);
    initReveal(root);
  }

  function initAll(scope) {
    if (!document.body.classList.contains('lv-design-on')) return;
    var context = scope || document;
    context.querySelectorAll('[data-lv-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Re-initialize when a section is added/re-rendered in the theme editor
  // without a full page reload.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
